export const getErrorCode = state => state.signup.errorCode;
export const getStatus = state => state.signup.status;
export const getEmailSent = state => state.signup.emailSent;
export const getIsLoading = state => state.signup.isLoading;
export const getFinishedGoogleSignupFirstStep = state => state.signup.finishedGoogleSignupFirstStep;
